export interface AccessTokenClaims {
  sub: string;
  tenant?: string;
  scope: string[];
  aud: string;
  exp: number;
}

export interface PlayerSessionTokenClaims {
  sub: string;
  tenant?: string;
  scope: Array<'player:read' | 'player:interact' | 'snapshot:create'>;
  productId: string;
  sceneId?: string;
  exp: number;
}

export interface ShareTokenPayload {
  configurationId: string;
  revision?: number;
  exp?: number;
}
